import { Card, Group, IconButton, iconSizes, Stack, TextInput, Title, Tooltip } from '@common/ui'
import { IconInfoCircle } from '@common/ui/icons'

export type LoginIdentifierFieldProps = {
  phone: string
  setPhone?: (value: string) => void
  email: string
  setEmail?: (value: string) => void
  phoneError?: string | undefined
  emailError?: string | undefined
  disabled?: boolean
}

const LoginIdentifierField = ({
  phone,
  setPhone,
  email,
  setEmail,
  phoneError,
  emailError,
  disabled = false,
}: LoginIdentifierFieldProps) => (
  <Card withBorder my="md">
    <Stack gap="md">
      <Title order={4}>User Login Identifiers</Title>
      <Group gap="xs" wrap="nowrap" align="center">
        <TextInput
          id="phoneLoginIdentifier"
          label="Access Phone Number"
          value={phone}
          onChange={(event) => setPhone && setPhone(event.target.value)}
          error={phoneError}
          disabled={disabled}
          style={{ flex: 1 }}
        />
        <Tooltip
          multiline
          maw={320}
          label="This phone number creates the user’s account and gives them access to the Field App. Changing or removing it will update or revoke their access."
        >
          <IconButton size="sm" aria-label="About the access phone number">
            <IconInfoCircle size={iconSizes.sm} stroke={1.5} />
          </IconButton>
        </Tooltip>
      </Group>
      <Group gap="xs" wrap="nowrap" align="center">
        <TextInput
          id="emailLoginIdentifier"
          label="Access Email"
          value={email}
          onChange={(event) => setEmail && setEmail(event.target.value)}
          error={emailError}
          disabled={disabled}
          style={{ flex: 1 }}
        />
        <Tooltip
          multiline
          maw={320}
          label="This Email creates the user’s account and gives them access to the EIDU Console. Changing or removing it will update or revoke their access."
        >
          <IconButton size="sm" aria-label="About the access email">
            <IconInfoCircle size={iconSizes.sm} stroke={1.5} />
          </IconButton>
        </Tooltip>
      </Group>
    </Stack>
  </Card>
)

export default LoginIdentifierField
